export default __webpack_public_path__ + "static/video-10-fb61d4b944f1611794e9ed19141c19be.png";